import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaTimesCircle } from 'react-icons/fa';
import useReject from './useReject';
import ActionButtonGradient from '../../../components/button/ActionButtonGradient';

const RejectModal = ({show, handleClose, user, setLoadingPage}) => {
    const {
        payload, 
        setPayload,
        handleReject,
    } = useReject()

    useEffect(() => {
        if (user) {
            setPayload(() => ({
                Comment: '',
                ProjectID: user.ProjectID,
                EmployeeID: user.EmployeeID,
                ProjectPhaseID: user.ProjectPhaseID,
                CalibratorID: user.CalibratorID,
            }))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    return (
        <>
        <style>
            {`
                .reject-modal .modal-content {
                    border: none;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
                }
                .reject-modal .modal-header {
                    border-bottom: 1px solid #e9ecef;
                    padding: 1.5rem 1.5rem 1rem 1.5rem;
                    background-color: #fff;
                    border-radius: 12px 12px 0 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .reject-modal .modal-title {
                    font-weight: 600;
                    color: #333;
                    font-size: 1.125rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    margin: 0;
                }
                .reject-modal .modal-body {
                    padding: 1rem 1.5rem 1.5rem 1.5rem;
                    background-color: #fff;
                    font-size: 14px;
                    color: #666;
                    line-height: 1.5;
                }
                .reject-modal .modal-footer {
                    border-top: 1px solid #e9ecef;
                    padding: 1rem 1.5rem 1.5rem 1.5rem;
                    background-color: #fff;
                    border-radius: 0 0 12px 12px;
                    display: flex;
                    gap: 0.5rem;
                    justify-content: center;
                }
                .reject-modal .btn {
                    border-radius: 8px;
                    padding: 0.5rem 1.25rem;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s ease;
                }
                .reject-modal .btn-danger {
                    background-color: #dc3545;
                    border-color: #dc3545;
                    color: white;
                }
                .reject-modal .btn-danger:hover {
                    background-color: #c82333;
                    border-color: #bd2130;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
                }
                .reject-modal .btn-secondary {
                    background-color: #6c757d;
                    border-color: #6c757d;
                    color: white;
                }
                .reject-modal .btn-secondary:hover {
                    background-color: #5a6268;
                    border-color: #545b62;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
                }
                .reject-icon {
                    color: #dc3545;
                    font-size: 1.125rem;
                }
                .reject-modal .form-control {
                    border-radius: 6px;
                    border: 1px solid #ced4da;
                    padding: 0.5rem 0.75rem;
                    font-size: 14px;
                    transition: border-color 0.2s ease;
                }
                .reject-modal .form-control:focus {
                    border-color: #dc3545;
                    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
                    outline: none;
                }
                .reject-modal .float-label label {
                    font-size: 13px;
                    font-weight: 500;
                    color: #495057;
                    margin-bottom: 0.375rem;
                    display: block;
                }
                .modern-label {
                    display: block;
                    font-weight: 500;
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 8px;
                    text-align: left;
                }
                .modern-textarea {
                    width: 100%;
                    padding: 12px;
                    border: 1px solid #d9d9d9;
                    border-radius: 8px;
                    font-size: 14px;
                    font-family: inherit;
                    resize: vertical;
                    transition: border-color 0.3s ease, box-shadow 0.3s ease;
                }
            `}
        </style>
        
        <Modal 
            show={show} 
            onHide={handleClose}
            backdrop="static" 
            centered
            className="reject-modal"
            size='md'
        >
            <Modal.Header>
                <Modal.Title>
                    <FaTimesCircle className="reject-icon" />
                    Reject Calibration
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-2 text-center"><strong>Are you sure you want to reject this calibration request?</strong></p>
                
                <label className="modern-label" htmlFor="Comment">
                    Comment
                </label>
                <textarea
                    maxLength="150" 
                    required
                    name="Comment"
                    id="Comment"
                    className="modern-textarea"
                    rows={4}
                    placeholder="Provide reasons related to why the employee's rating has changed"
                    onChange={(e) => setPayload((prev) => ({
                        ...prev,
                        Comment: e.target.value
                    }))}
                    value={payload.Comment}
                />
            </Modal.Body>
            <Modal.Footer>
                <ActionButtonGradient
                    onClick={handleClose}
                    variant='secondary'
                    children={"Cancel"}
                />
                <ActionButtonGradient
                    onClick={() => {
                        handleReject(setLoadingPage, handleClose)
                    }}
                    variant='danger'
                    children={"Reject"}
                />
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default RejectModal